export default __webpack_public_path__ + "static/media/v-31.961a2e8d.svg";